// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"532ca647","224":"f50dec0b","239":"12cd8ff5","425":"1334b72c","453":"85d62397","455":"8b85bc34","613":"83634d20","626":"385b9156","707":"31f0e2e8","839":"e89959ce","870":"c2806584"}[chunkId] + ".chunk.js";
};